module.exports = __webpack_public_path__ + "img/pantalon.9908c090.png";